import { StyledIllustration } from "@kaltura/mediaspace-shared-ui";

export const BannerImage = ({ isSmallScreen }: { isSmallScreen: boolean }) => {
    return isSmallScreen ? (
        <StyledIllustration
            fileName={"GenieBanner.svg"}
            width="200"
            height="200"
            viewBox="0 0 200 200"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_8569_26013)">
                <path
                    d="M34.6665 106.667C34.6665 73.1614 61.8279 46 95.3332 46V46C128.838 46 156 73.1614 156 106.667V148.667H34.6665V106.667Z"
                    fill="#006EFA"
                />
                <path
                    d="M52 112C52 83.2812 75.2812 60 104 60V60C132.719 60 156 83.2812 156 112V148.667H52V112Z"
                    fill="#5BC686"
                />
                <path
                    d="M69.3335 114.667C69.3335 90.7342 88.7345 71.3333 112.667 71.3333V71.3333C136.599 71.3333 156 90.7342 156 114.667V148.667H69.3335V114.667Z"
                    fill="#FFD357"
                />
                <path
                    d="M86.6665 119.333C86.6665 100.188 102.187 84.6667 121.333 84.6667V84.6667C140.479 84.6667 156 100.188 156 119.333V148.667H86.6665V119.333Z"
                    fill="#FF9DFF"
                />
                <path
                    d="M104 124C104 109.641 115.641 98 130 98V98C144.359 98 156 109.641 156 124V148.667H104V124Z"
                    fill="#FF3D23"
                />
                <path
                    d="M127.248 121.922L144.718 93.4602L166.771 122.863L136.77 133.636C129.656 136.19 123.294 128.364 127.248 121.922Z"
                    fill="#333333"
                />
                <ellipse cx="161.519" cy="103.958" rx="19.9528" ry="19.952" fill="#006EFA" />
                <path
                    d="M160.655 93.9482C153.31 95.5764 149.928 102.705 148.692 106.408C148.451 107.131 148.668 107.921 149.243 108.42C151.865 110.696 157.674 114.687 164.897 113.085C172.204 111.466 175.496 105.335 176.687 102.239C176.93 101.606 176.805 100.898 176.364 100.383C173.914 97.5251 168.078 92.3025 160.655 93.9482Z"
                    fill="white"
                />
                <ellipse
                    cx="6.86463"
                    cy="6.86437"
                    rx="6.86463"
                    ry="6.86437"
                    transform="matrix(0.976298 -0.216431 0.216448 0.976294 154.843 98.2422)"
                    fill="#282828"
                />
                <rect
                    x="12.3218"
                    y="126.547"
                    width="63.0347"
                    height="48.2804"
                    rx="5.33333"
                    transform="rotate(-5.3899 12.3218 126.547)"
                    fill="#B6D7FF"
                />
                <circle
                    cx="46.3024"
                    cy="147.636"
                    r="11.9035"
                    transform="rotate(-5.3899 46.3024 147.636)"
                    fill="white"
                />
                <path
                    d="M50.8036 146.061C51.7292 146.485 51.8488 147.752 51.0188 148.342L45.4161 152.322C44.5861 152.912 43.429 152.382 43.3334 151.368L42.6879 144.526C42.5922 143.513 43.6297 142.775 44.5554 143.199L50.8036 146.061Z"
                    fill="#006EFA"
                />
                <path
                    d="M167.271 58.7003C167.032 59.2143 166.301 59.2143 166.062 58.7003L162.189 50.3724C162.121 50.2263 162.002 50.1097 161.855 50.0443L153.372 46.2758C152.844 46.0413 152.844 45.2919 153.372 45.0573L161.855 41.2889C162.002 41.2235 162.121 41.1069 162.189 40.9608L166.062 32.6329C166.301 32.1189 167.032 32.1189 167.271 32.6329L171.145 40.9608C171.213 41.1069 171.331 41.2235 171.478 41.2889L179.962 45.0573C180.49 45.2919 180.49 46.0413 179.962 46.2758L171.478 50.0443C171.331 50.1097 171.213 50.2263 171.145 50.3724L167.271 58.7003Z"
                    fill="#FFD357"
                />
                <path
                    d="M177.94 149.998C177.704 150.519 176.963 150.519 176.727 149.998L174.937 146.061C174.87 145.914 174.753 145.797 174.606 145.73L170.669 143.94C170.148 143.703 170.148 142.963 170.669 142.726L174.606 140.937C174.753 140.87 174.87 140.752 174.937 140.606L176.727 136.668C176.963 136.147 177.704 136.147 177.94 136.668L179.73 140.606C179.797 140.752 179.914 140.87 180.061 140.937L183.998 142.726C184.519 142.963 184.519 143.703 183.998 143.94L180.061 145.73C179.914 145.797 179.797 145.914 179.73 146.061L177.94 149.998Z"
                    fill="#006EFA"
                />
                <path
                    d="M15.2734 85.998C15.0366 86.5191 14.2964 86.5191 14.0596 85.998L12.27 82.0608C12.2033 81.9141 12.0857 81.7965 11.9389 81.7298L8.00171 79.9402C7.48064 79.7033 7.48065 78.9632 8.00171 78.7263L11.9389 76.9367C12.0857 76.87 12.2033 76.7524 12.27 76.6057L14.0596 72.6685C14.2964 72.1474 15.0366 72.1474 15.2734 72.6685L17.0631 76.6057C17.1298 76.7524 17.2474 76.87 17.3941 76.9367L21.3313 78.7263C21.8524 78.9632 21.8524 79.7033 21.3313 79.9402L17.3941 81.7298C17.2474 81.7965 17.1298 81.9141 17.0631 82.0608L15.2734 85.998Z"
                    fill="#5BC686"
                />
                <path
                    d="M44.5473 43.3296C44.0736 44.3717 42.5934 44.3717 42.1197 43.3296L38.5404 35.4552C38.407 35.1617 38.1718 34.9265 37.8783 34.7931L30.0039 31.2138C28.9618 30.7401 28.9618 29.2599 30.0039 28.7862L37.8783 25.2069C38.1718 25.0735 38.407 24.8383 38.5404 24.5448L42.1197 16.6704C42.5934 15.6283 44.0736 15.6283 44.5473 16.6704L48.1266 24.5448C48.26 24.8383 48.4952 25.0735 48.7887 25.2069L56.6631 28.7862C57.7052 29.2599 57.7052 30.7401 56.6631 31.2138L48.7887 34.7931C48.4952 34.9265 48.26 35.1617 48.1266 35.4552L44.5473 43.3296Z"
                    fill="#FF9DFF"
                />
            </g>
            <defs>
                <clipPath id="clip0_8569_26013">
                    <rect width="200" height="200" fill="white" />
                </clipPath>
            </defs>
        </StyledIllustration>
    ) : (
        <StyledIllustration
            fileName={"GenieBanner.svg"}
            width="491"
            height="300"
            viewBox="0 0 491 300"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M159 160C159 109.742 199.742 69 250 69V69C300.258 69 341 109.742 341 160V223H159V160Z"
                fill="#006EFA"
            />
            <path
                d="M185 168C185 124.922 219.922 90 263 90V90C306.078 90 341 124.922 341 168V223H185V168Z"
                fill="#5BC686"
            />
            <path
                d="M211 172C211 136.101 240.101 107 276 107V107C311.899 107 341 136.101 341 172V223H211V172Z"
                fill="#FFD357"
            />
            <path
                d="M237 179C237 150.281 260.281 127 289 127V127C317.719 127 341 150.281 341 179V223H237V179Z"
                fill="#FF9DFF"
            />
            <path
                d="M263 186C263 164.461 280.461 147 302 147V147C323.539 147 341 164.461 341 186V223H263V186Z"
                fill="#FF3D23"
            />
            <path
                d="M297.872 182.883L324.076 140.19L357.156 184.295L312.155 200.454C301.483 204.286 291.941 192.546 297.872 182.883Z"
                fill="#333333"
            />
            <ellipse cx="349.278" cy="155.936" rx="29.9292" ry="29.928" fill="#006EFA" />
            <path
                d="M347.982 140.922C336.965 143.365 331.892 154.057 330.039 159.612C329.677 160.696 330.002 161.881 330.865 162.63C334.798 166.044 343.512 172.03 354.346 169.628C365.306 167.199 370.245 158.003 372.03 153.358C372.395 152.408 372.208 151.347 371.546 150.575C367.871 146.287 359.118 138.454 347.982 140.922Z"
                fill="white"
            />
            <ellipse
                cx="10.2969"
                cy="10.2966"
                rx="10.2969"
                ry="10.2966"
                transform="matrix(0.976298 -0.216431 0.216448 0.976294 339.264 147.363)"
                fill="#282828"
            />
            <rect
                x="125.483"
                y="189.821"
                width="94.552"
                height="72.4206"
                rx="8"
                transform="rotate(-5.3899 125.483 189.821)"
                fill="#B6D7FF"
            />
            <circle cx="176.453" cy="221.454" r="17.8552" transform="rotate(-5.3899 176.453 221.454)" fill="white" />
            <path
                d="M183.205 219.092C184.593 219.728 184.773 221.629 183.528 222.513L175.124 228.483C173.879 229.368 172.143 228.573 171.999 227.052L171.031 216.789C170.888 215.269 172.444 214.163 173.832 214.799L183.205 219.092Z"
                fill="#006EFA"
            />
            <path
                d="M430.407 109.051C430.048 109.822 428.952 109.822 428.593 109.051L422.783 96.5587C422.681 96.3395 422.503 96.1647 422.282 96.0665L409.557 90.4139C408.765 90.062 408.765 88.938 409.557 88.5861L422.282 82.9335C422.503 82.8353 422.681 82.6605 422.783 82.4413L428.593 69.9495C428.952 69.1784 430.048 69.1784 430.407 69.9494L436.217 82.4413C436.319 82.6605 436.497 82.8353 436.718 82.9335L449.443 88.5861C450.235 88.938 450.235 90.062 449.443 90.4139L436.718 96.0665C436.497 96.1647 436.319 96.3395 436.217 96.5587L430.407 109.051Z"
                fill="#FFD357"
            />
            <path
                d="M387.91 232.997C387.555 233.779 386.445 233.779 386.09 232.997L383.405 227.091C383.305 226.871 383.129 226.695 382.909 226.595L377.003 223.91C376.221 223.555 376.221 222.445 377.003 222.09L382.909 219.405C383.129 219.305 383.305 219.129 383.405 218.909L386.09 213.003C386.445 212.221 387.555 212.221 387.91 213.003L390.595 218.909C390.695 219.129 390.871 219.305 391.091 219.405L396.997 222.09C397.779 222.445 397.779 223.555 396.997 223.91L391.091 226.595C390.871 226.695 390.695 226.871 390.595 227.091L387.91 232.997Z"
                fill="#006EFA"
            />
            <path
                d="M60.9104 158.997C60.5551 159.779 59.4449 159.779 59.0896 158.997L56.4052 153.091C56.3051 152.871 56.1287 152.695 55.9086 152.595L50.0028 149.91C49.2212 149.555 49.2212 148.445 50.0028 148.09L55.9086 145.405C56.1287 145.305 56.3051 145.129 56.4052 144.909L59.0896 139.003C59.4449 138.221 60.5551 138.221 60.9104 139.003L63.5948 144.909C63.6949 145.129 63.8713 145.305 64.0914 145.405L69.9972 148.09C70.7788 148.445 70.7788 149.555 69.9972 149.91L64.0914 152.595C63.8713 152.695 63.6949 152.871 63.5948 153.091L60.9104 158.997Z"
                fill="#5BC686"
            />
            <path
                d="M126.821 91.9944C126.11 93.5576 123.89 93.5576 123.179 91.9944L117.81 80.1828C117.61 79.7426 117.257 79.3897 116.817 79.1896L105.006 73.8207C103.442 73.1102 103.442 70.8898 105.006 70.1793L116.817 64.8104C117.257 64.6103 117.61 64.2574 117.81 63.8172L123.179 52.0056C123.89 50.4424 126.11 50.4424 126.821 52.0056L132.19 63.8172C132.39 64.2574 132.743 64.6103 133.183 64.8104L144.994 70.1793C146.558 70.8898 146.558 73.1102 144.994 73.8207L133.183 79.1896C132.743 79.3897 132.39 79.7426 132.19 80.1828L126.821 91.9944Z"
                fill="#FF9DFF"
            />
        </StyledIllustration>
    );
};
